import axios from 'axios';
import { hostUI } from '../../configuraciones';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
    inventario: {
        todos: [],
        porTipo: {
            granel: [],
            barrica: [],
            vidrio: []
        },
        resumen: {
            totalLotes: 0,
            totalGranelLitros: 0,
            totalBarricasCount: 0,
            totalBarricaLitros: 0,
            totalVidrioLitros: 0
        }
    },
    loading: false,
    error: null
};

const OBTENER_INVENTARIO_POR_ANEXO = 'inventarioInstalacion/obtenerPorAnexo';

export const obtenerInventarioPorAnexoAccion = createAsyncThunk(
    OBTENER_INVENTARIO_POR_ANEXO,
    async (idAnexo, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('user');
            const headers = token ? { authorization: token } : {};
            const res = await axios.get(`${hostUI}Inventario/anexo/${idAnexo}`, { headers });
            return res.data.data;
        } catch (error) {
            console.error('Error al obtener inventario por anexo:', error);
            return rejectWithValue(error.response?.data?.message || error.message || 'No se pudo cargar la información del inventario de la instalación.');
        }
    }
);

const inventarioInstalacionSlice = createSlice({
    name: 'inventarioInstalacion',
    initialState,
    reducers: {
        limpiarInventario: (state) => {
            state.inventario = initialState.inventario;
            state.error = null;
            state.loading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(obtenerInventarioPorAnexoAccion.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(obtenerInventarioPorAnexoAccion.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.inventario = payload || initialState.inventario;
            })
            .addCase(obtenerInventarioPorAnexoAccion.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            });
    }
});

export const { limpiarInventario } = inventarioInstalacionSlice.actions;
export default inventarioInstalacionSlice.reducer;
